/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { MockFeePool } from '../MockFeePool'

export class MockFeePool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(_token: string, overrides?: Overrides): Promise<MockFeePool> {
    return super.deploy(_token, overrides || {}) as Promise<MockFeePool>
  }
  getDeployTransaction(
    _token: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_token, overrides || {})
  }
  attach(address: string): MockFeePool {
    return super.attach(address) as MockFeePool
  }
  connect(signer: Signer): MockFeePool__factory {
    return super.connect(signer) as MockFeePool__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockFeePool {
    return new Contract(address, _abi, signerOrProvider) as MockFeePool
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_token',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '_amount',
        type: 'uint256'
      }
    ],
    name: 'sendProfitERC20',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'token',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '0x60a06040523480156200001157600080fd5b5060405162000c0638038062000c0683398101604081905262000034916200015a565b604080518082018252600c81526b6d6f636b207374616b696e6760a01b602080830191825283518085019094526005845264734d4f434b60d81b9084015281519192916200008591600391620000b4565b5080516200009b906004906020840190620000b4565b50505060601b6001600160601b031916608052620001c7565b828054620000c2906200018a565b90600052602060002090601f016020900481019282620000e6576000855562000131565b82601f106200010157805160ff191683800117855562000131565b8280016001018555821562000131579182015b828111156200013157825182559160200191906001019062000114565b506200013f92915062000143565b5090565b5b808211156200013f576000815560010162000144565b6000602082840312156200016c578081fd5b81516001600160a01b038116811462000183578182fd5b9392505050565b6002810460018216806200019f57607f821691505b60208210811415620001c157634e487b7160e01b600052602260045260246000fd5b50919050565b60805160601c610a19620001ed600039600081816101f001526103c10152610a196000f3fe608060405234801561001057600080fd5b50600436106100cf5760003560e01c8063395093511161008c578063a457c2d711610066578063a457c2d71461018c578063a9059cbb1461019f578063dd62ed3e146101b2578063fc0c546a146101eb576100cf565b8063395093511461015e57806370a082311461017157806395d89b4114610184576100cf565b806306fdde03146100d4578063095ea7b3146100f257806318160ddd1461011557806323b872dd14610127578063313ce5671461013a578063359f446014610149575b600080fd5b6100dc61022a565b6040516100e99190610939565b60405180910390f35b6101056101003660046108f0565b6102bc565b60405190151581526020016100e9565b6002545b6040519081526020016100e9565b6101056101353660046108b5565b6102d2565b604051601281526020016100e9565b61015c6101573660046108f0565b610388565b005b61010561016c3660046108f0565b610442565b61011961017f366004610862565b610479565b6100dc610498565b61010561019a3660046108f0565b6104a7565b6101056101ad3660046108f0565b610542565b6101196101c0366004610883565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6102127f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b0390911681526020016100e9565b606060038054610239906109bb565b80601f0160208091040260200160405190810160405280929190818152602001828054610265906109bb565b80156102b25780601f10610287576101008083540402835291602001916102b2565b820191906000526020600020905b81548152906001019060200180831161029557829003601f168201915b5050505050905090565b60006102c933848461054f565b50600192915050565b60006102df848484610673565b6001600160a01b0384166000908152600160209081526040808320338452909152902054828110156103695760405162461bcd60e51b815260206004820152602860248201527f45524332303a207472616e7366657220616d6f756e74206578636565647320616044820152676c6c6f77616e636560c01b60648201526084015b60405180910390fd5b61037d853361037886856109a4565b61054f565b506001949350505050565b6000811161039557600080fd5b6040516323b872dd60e01b81526001600160a01b038381166004830152306024830152604482018390527f000000000000000000000000000000000000000000000000000000000000000016906323b872dd90606401602060405180830381600087803b15801561040557600080fd5b505af1158015610419573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061043d9190610919565b505050565b3360008181526001602090815260408083206001600160a01b038716845290915281205490916102c991859061037890869061098c565b6001600160a01b0381166000908152602081905260409020545b919050565b606060048054610239906109bb565b3360009081526001602090815260408083206001600160a01b0386168452909152812054828110156105295760405162461bcd60e51b815260206004820152602560248201527f45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77604482015264207a65726f60d81b6064820152608401610360565b610538338561037886856109a4565b5060019392505050565b60006102c9338484610673565b6001600160a01b0383166105b15760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b6064820152608401610360565b6001600160a01b0382166106125760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610360565b6001600160a01b0383811660008181526001602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6001600160a01b0383166106d75760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b6064820152608401610360565b6001600160a01b0382166107395760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b6064820152608401610360565b6001600160a01b038316600090815260208190526040902054818110156107b15760405162461bcd60e51b815260206004820152602660248201527f45524332303a207472616e7366657220616d6f756e7420657863656564732062604482015265616c616e636560d01b6064820152608401610360565b6107bb82826109a4565b6001600160a01b0380861660009081526020819052604080822093909355908516815290812080548492906107f190849061098c565b92505081905550826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8460405161083d91815260200190565b60405180910390a350505050565b80356001600160a01b038116811461049357600080fd5b600060208284031215610873578081fd5b61087c8261084b565b9392505050565b60008060408385031215610895578081fd5b61089e8361084b565b91506108ac6020840161084b565b90509250929050565b6000806000606084860312156108c9578081fd5b6108d28461084b565b92506108e06020850161084b565b9150604084013590509250925092565b60008060408385031215610902578182fd5b61090b8361084b565b946020939093013593505050565b60006020828403121561092a578081fd5b8151801515811461087c578182fd5b6000602080835283518082850152825b8181101561096557858101830151858201604001528201610949565b818111156109765783604083870101525b50601f01601f1916929092016040019392505050565b6000821982111561099f5761099f6109f6565b500190565b6000828210156109b6576109b66109f6565b500390565b6002810460018216806109cf57607f821691505b602082108114156109f057634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fdfea164736f6c6343000802000a'
